import {
  RequirementWorkflowType,
  type WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";

import { type WorkerRequirement } from "../Documents/api/types";

export function filterOutBackgroundCheckRequirements(
  workerRequirements: WorkerRequirement[],
  filter?: {
    status?: WorkerRequirementStatus[];
  }
): WorkerRequirement[] {
  return workerRequirements.filter((workerRequirement) => {
    if (
      workerRequirement.requirement?.attributes.requirementWorkflowType !==
      RequirementWorkflowType.CHECKR_BACKGROUND_CHECK
    ) {
      return true;
    }

    if (isDefined(filter?.status)) {
      return !filter.status.includes(workerRequirement.status);
    }

    return false;
  });
}
